var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useScrollIntoView } from '../useScrollIntoView';
export var useScrollFromAnchor = function (anchor, behavior) {
    var _a = __read(useScrollIntoView(), 2), scrollRef = _a[0], onScroll = _a[1];
    var asPath = useRouter().asPath;
    useEffect(function () {
        var hash = asPath === null || asPath === void 0 ? void 0 : asPath.split('#')[1];
        if (hash === anchor) {
            onScroll({ behavior: behavior });
        }
    });
    return [scrollRef];
};
